import { IRPC } from '@prisma/studio-types'
import { BIGINT_PREFIX, BYTES_PREFIX } from './serialize'

export default function deserialize<T extends IRPC>(
  msg: string
): T['request'] | T['response'] {
  return JSON.parse(msg, (_, value) => {
    if (typeof value === 'string' && value.startsWith(BIGINT_PREFIX)) {
      return BigInt(value.substr(BIGINT_PREFIX.length))
    }
    if (typeof value === 'string' && value.startsWith(BYTES_PREFIX)) {
      return value.substr(BYTES_PREFIX.length) // This will be a base64-enocoded string
    }
    return value
  })
}
